var orderUtils = {
    BaseUrl: function (url) {
        if (process.env.NODE_ENV === 'development') {
            // return '/api/order' + url;
            return 'https://testorder.zhengzai.tv' + url;
        } else if (window.location.hostname.indexOf('dev') !== -1) {
            return 'https://devorder.zhengzai.tv' + url;
        } else if (window.location.hostname.indexOf('test') !== -1 || window.location.hostname.indexOf('cangpin') !== -1) {
            if (window.location.hostname.indexOf('test2') !== -1) {
                return 'https://test2order.zhengzai.tv' + url;
            } else {
                return 'https://testorder.zhengzai.tv' + url;
            }
        } else {
            return 'https://order.zhengzai.tv' + url;
        }
    }
};

export default orderUtils;
